import { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import { Modal } from 'common/components/layout';
import { skipShipment } from 'redux/clubMemberShipments/actions';

class SkipShipmentModal extends Component {
  handleSubmit = () => {
    const { props } = this;
    const successFunction = () => {
      props.onCloseModal();
    };
    props.skipShipment(props.clubMemberShipmentId, successFunction);
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { onCloseModal } = this.props;
    return (
      <Modal title="Skip This Shipment" onCloseModal={onCloseModal}>
        <p>Would you like to skip this shipment?</p>
        <div className="c7-form__button-row">
          <a onClick={this.handleClose} className="c7-button-alt">
            Cancel
          </a>
          <button
            type="button"
            onClick={this.handleSubmit}
            className="c7-button"
          >
            Skip this shipment
          </button>
        </div>
      </Modal>
    );
  }
}

export default connect(null, {
  skipShipment
})(SkipShipmentModal);
